import React from 'react';
import { FadeIn } from './Shared';
import { Quote } from 'lucide-react';
interface TestimonialProps {
  quote: string;
  author: string;
  location: string;
}
const TestimonialCard = ({
  quote,
  author,
  location
}: TestimonialProps) => <div className="bg-navy-900/40 p-6 md:p-8 rounded-2xl border border-white/10 relative h-full flex flex-col hover:border-white/20 transition-colors" data-id="element-338">
    <Quote className="absolute top-6 right-6 w-8 h-8 text-orange-500/10" data-id="element-339" />
    <div className="text-orange-400 mb-5 text-xs flex gap-1" data-id="element-340">
      {[...Array(5)].map((_, i) => <span key={i} data-id="element-341">⭐</span>)}
    </div>
    <p className="text-base md:text-lg text-gray-100 font-sans mb-6 relative z-10 flex-grow leading-relaxed opacity-95" data-id="element-342">
      "{quote}"
    </p>
    <div className="border-t border-white/5 pt-5 mt-auto" data-id="element-343">
      <div className="font-bold text-white tracking-wide text-sm mb-1 font-sans" data-id="element-344">
        {author}
      </div>
      <div className="text-[10px] md:text-[11px] text-gray-400 font-bold uppercase tracking-wider font-sans" data-id="element-345">
        {location}
      </div>
    </div>
  </div>;
export const Testimonials = () => {
  return <section className="py-16 md:py-24 px-4 bg-navy-950 relative overflow-hidden" data-id="element-346">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(255,165,0,0.03),transparent_70%)] pointer-events-none" data-id="element-347"></div>
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-348">
        <FadeIn data-id="element-349">
          <div className="grid md:grid-cols-3 gap-6" data-id="element-350">
            <TestimonialCard quote="La primera semana de aplicar el Tomo 1 el ladrido bajó a la mitad. El Protocolo de Salida Fantasma funciona de verdad." author="Valeria G." location="Palermo, CABA" data-id="element-351" />
            <TestimonialCard quote="Por fin entendí por qué mi perro ladraba exactamente en el minuto 15. El Tomo 2 me lo explicó todo y lo resolví en 4 días." author="Lucas M." location="Villa Crespo, CABA" data-id="element-352" />
            <TestimonialCard quote="Pensé que era cuestión de raza. El Tomo 1 me cambió la cabeza. Ahora sé que era yo sin herramientas." author="Sofía R." location="San Isidro, GBA" data-id="element-353" />
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const MoreTestimonials = () => {
  return <section className="py-16 md:py-24 px-4 bg-navy-900/50 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-354">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-355">
        <FadeIn data-id="element-356">
          <div className="flex flex-col items-center mb-16" data-id="element-357">
            <div className="bg-red-500/10 text-red-400 px-6 py-2 rounded-full border border-red-500/20 text-xs font-bold tracking-[0.2em] mb-6 uppercase font-sans" data-id="element-358">
              HISTORIAS REALES
            </div>
            <h2 className="text-3xl md:text-5xl text-center text-white leading-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-359">
              ❤️ MÁS DUEÑOS QUE YA LO TIENEN
            </h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-360">
            <TestimonialCard quote="El Protocolo de Salida Fantasma me cambió todo. Antes de tenerlo cada mañana era una escena. Ahora cierro la puerta y hay silencio del otro lado." author="Cecilia R." location="Mendoza · Método Silencio Total + Anti-Recaídas" data-id="element-361" />
            <TestimonialCard quote="El Bono 1 me salvó. El encargado me había parado tres veces. Con el script de WhatsApp manejé la situación sin pelearme con nadie y sin perder tiempo." author="Roberto M." location="Buenos Aires · Método Silencio Total" data-id="element-362" />
            <TestimonialCard quote="El Protocolo Anti-Recaídas me hizo entender que la tormenta de junio no era una recaída del sistema. Era que nunca había preparado el búnker. Una semana de desensibilización preventiva en octubre y el 31 de diciembre fue una noche normal." author="Sofía C." location="La Plata · Método + Anti-Recaídas" data-id="element-363" />
            <TestimonialCard quote="El Tomo 4 sobre la química me voló la cabeza. Solo con cambiar el horario de la comida y agregar el aceite de pescado la consistencia de los resultados mejoró una barbaridad." author="Pablo A." location="Neuquén · Método Silencio Total" data-id="element-364" />
            <TestimonialCard quote="Mi perra de 4 años empezó a ir sola al refugio dentro de los primeros 5 minutos de que yo salía. En dos semanas. Eso no tiene precio cuando vivís en un edificio." author="Daniela M." location="Rosario · Método Silencio Total" data-id="element-365" />
          </div>
        </FadeIn>
      </div>
    </section>;
};